import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { map, Observable, of } from 'rxjs';
import { Event } from '@reg/shared/model';
import { AuthService, EventService } from '@reg/shared/service';
import { AuthGuard } from '@reg/shared/auth/auth.guard';

/**
 * This guard is meant to be used for routes that should not be loadable
 * without authenticating with FloSports and the user has access to the given event and the event cannot
 * be a dual (isDual) event. If they do not have access to they will be redirected to an access denied page.
 */
@Injectable()
export class EventNoDualAuthGuard extends AuthGuard {
    constructor(
protected eventService: EventService,
                protected authService: AuthService,
                protected router: Router,
    ) {
        super(authService, router);
    }

    public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        const eventId: string = route.params['event-id'] || (route.firstChild && route.firstChild.params['event-id']);

        if (super.canActivate(route, state)) {
            if (this.authService.isUserAdmin()) {
                // Allow admins to manage the event through event-setup
                return of(true);
            }

            return this.eventService.get(eventId).pipe(map((event: Event) => {
                if (event.isDual) {
                    this.router.navigate(['error', 'access-denied-event-dual']);
                }

                return !event.isDual;
            }));
        }
    }
}
